import type { ElementType } from 'react';
import {
  House, MagnifyingGlass, Files, Bell, Tray, Database, Plugs, GearSix,
  ClockCounterClockwise, UsersThree, UserCircle,
} from '@phosphor-icons/react';

/**
 * The sidebar's entries. They live here, not in `_layout.tsx`, so a test can
 * read them without mounting the layout's Firebase-backed providers.
 *
 * The INTELLIGENCE section (the BigQuery /analytics pages, and Custom Reports and
 * Metric Builder) was RETIRED on 2026-10-29: spec
 * docs/superpowers/specs/2026-10-29-analytics-on-dashboard-design.md. The
 * Dashboard is the analytics now. Do not add an /analytics entry back;
 * `retired-analytics.test.ts` refuses it.
 */
export type NavEntry =
  | { type: 'section_label'; label: string }
  | { type: 'spacer' }
  | {
      type: 'item';
      path: string;
      label: string;
      icon: ElementType;
      roles?: string[];
      highlight?: boolean;
      exact?: boolean;
    };

export const NAV_CONFIG: NavEntry[] = [
  { type: 'item', path: '/', label: 'Dashboard', icon: House, exact: true },

  { type: 'section_label', label: 'OPERATIONS' },
  { type: 'item', path: '/search', label: 'Transaction Search', icon: MagnifyingGlass },
  { type: 'item', path: '/lookup', label: 'Manual Dispute Lookup', icon: MagnifyingGlass },
  { type: 'item', path: '/cases', label: 'Dispute Management', icon: Files },
  { type: 'item', path: '/alerts', label: 'Alert Management', icon: Bell },
  { type: 'item', path: '/operations/inbound', label: 'Inbound Queue', icon: Tray },
  { type: 'item', path: '/operations/webhooks', label: 'Webhook Events', icon: Database },
  { type: 'item', path: '/operations/ingestion', label: 'Ingestion', icon: Database },

  { type: 'spacer' },
  { type: 'item', path: '/settings/integrations', label: 'Integrations', icon: Plugs, roles: ['tenant_admin', 'super_admin', 'kombatix_qa'] },
  { type: 'item', path: '/settings/actions', label: 'Case Actions', icon: GearSix, roles: ['tenant_admin', 'super_admin', 'kombatix_qa'] },
  { type: 'item', path: '/settings/audit', label: 'Audit Log', icon: ClockCounterClockwise, roles: ['tenant_admin', 'super_admin', 'kombatix_qa'] },
  { type: 'item', path: '/settings/team', label: 'Team', icon: UsersThree, roles: ['tenant_admin', 'super_admin', 'kombatix_qa'] },
  { type: 'item', path: '/settings/account', label: 'Settings', icon: UserCircle },
];
